<template>
  <div :class="$style.currentLevelContentProgress">
    <span v-if="currentLevelData" :class="$style.currentLevelContentProgressLevel">
      {{ currentLevelData.title }}
    </span>
    <span>{{ playerCompPointsNumber }} {{ pointsTitle }}</span>
    <div
      :class="[$style.currentLevelContentProgressBar, { [$style.shiningLastLevel]: isLastLevel }]"
    >
      <div
        :class="$style.currentLevelContentProgressBarValue"
        :style="{ width: progressToNextLevel }"
      />
    </div>
    <div v-if="!isLastLevel" :class="$style.currentLevelContentProgressNext">
      <span>{{ toNextLevelTitle }}</span>
      <span>{{ compPointsNextLevel }}</span>
    </div>
    <div v-else :class="$style.currentLevelContentProgressLast">
      <span>{{ maxLevelTitle }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import { useStoreVipLevelData } from '~/stores/strapi/vipLevelData';

defineProps({
  pointsTitle: {
    type: String,
    required: true,
  },
  toNextLevelTitle: {
    type: String,
    required: true,
  },
  maxLevelTitle: {
    type: String,
    required: true,
  },
});

const storeSsPlayer = useStoreSsPlayer();
const storeVipLevelData = useStoreVipLevelData();

/**
 * Getting percent of current progress to player's next VIP Level
 */
const progressToNextLevel = computed(() => {
  if (storeVipLevelData.compPointsNextLevel !== null) {
    if (storeSsPlayer.playerCompPointsNumber === 0) {
      return '0%';
    }

    let percent = Math.floor(
      (storeSsPlayer.playerCompPointsNumber / storeVipLevelData.compPointsNextLevel) * 100
    );

    percent = percent < 1 ? 1 : percent;

    return `${percent}%`;
  } else {
    return '100%';
  }
});

const isLastLevel = computed(
  () =>
    storeVipLevelData.currentLevelData?.level ===
    storeVipLevelData.data[storeVipLevelData.data.length - 1].level
);

const playerCompPointsNumber = computed(() => storeSsPlayer.playerCompPointsNumber);
const compPointsNextLevel = computed(() => storeVipLevelData.compPointsNextLevel);
const currentLevelData = computed(() => storeVipLevelData.currentLevelData);
</script>

<style lang="scss" module src="./progress.scss"></style>
